{
  "match_play": "Matchspel",
  "match_play_format": "Matchspel",
  "match_play_management": "Matchspelshantering",
  "play_mode": "Spelläge",
  "bracket": "Schema",
  "league": "Liga",
  "ryder_cup": "Lagmatch (Ryder Cup-stil)",
  "scoring_type": "Resultatberäkning",
  "stableford": "Poängbogey",
  "stroke_play": "Slagspel",
  "result_entry": "Resultatinmatning",
  "result_only": "Endast resultat",
  "hole_by_hole": "Hål för hål",
  "seeding_method": "Seedningsmetod",
  "by_handicap": "Enligt handikapp",
  "random": "Slumpmässig",
  "manual": "Manuell",
  "generate_bracket": "Skapa schema",
  "bracket_generated": "Schema skapat",
  "participants": "Spelare",
  "participant_a": "Spelare A",
  "participant_b": "Spelare B",
  "tee_time": "Kl.",
  "match": "Match",
  "club": "Klubb",
  "handicap": "Handikapp",
  "status": "Status",
  "result": "Resultat",
  "winner": "Vinnare",
  "result_not_available": "N/A",
  "bye": "Väntar på motståndare",
  "not_started": "Ej påbörjad",
  "in_progress": "Pågående",
  "completed": "Avslutad",
  "enter_result": "Ange resultat",
  "enter_match_result": "Ange matchresultat",
  "select_winner": "Välj vinnare",
  "result_notation": "Resultatnotering",
  "result_notation_help": "T.ex. '3/2', '1 up', 'A/S'",
  "result_notation_custom_placeholder": "Anpassad notering…",
  "holes_completed": "Spelade hål",
  "match_format_short": "Match Play",
  "holes_played_short": "{{n}} hål",
  "hole_range_chip": "Hål: {{start}}–{{end}}",
  "vs_short": "vs",
  "handicap_short": "HCP",
  "result_saved": "Resultat sparat",
  "round_n": "Runda {{n}}",
  "format_created": "Format skapat",
  "format_updated": "Format uppdaterat",
  "format_deleted": "Format raderat",
  "confirm_delete_format": "Vill du verkligen radera match play-formatet?",
  "no_participations": "Inga spelare",
  "no_bracket_yet": "Schemat har inte skapats ännu",
  "minimum_two_participants": "Minst två spelare krävs",
  "unnamed_participant": "Namnlös spelare",
  "play_mode_help": "Välj tävlingens spelformat",
  "scoring_type_help": "Välj poängräkningssystem",
  "result_entry_help": "Välj inmatningssätt för resultat",
  "seeding_method_help": "Välj seedningsmetod för spelare",
  "setup_instructions_title": "Instruktioner:",
  "setup_step_1": "Skapa match play-format genom att välja spelformat och poängräkning",
  "setup_step_2": "Välj spelare och skapa schema",
  "setup_step_3": "Ange matchresultat allt eftersom de slutförs",
  "back_to_competition": "Tillbaka till tävlingen",
  "select_series": "Välj serie",
  "no_series_available": "Inga serier har skapats för tävlingen. Skapa serier först på fliken Serier.",
  "create_format": "Skapa format",
  "update_format": "Uppdatera format",
  "create_bracket": "Skapa schema",
  "recreate_bracket": "Skapa om schema",
  "bracket_created": "Schema skapat",
  "no_bracket_created": "Schemat har inte skapats ännu",
  "click_create_to_start": "Skapa schema genom att välja spelare och spelformat.",
  "series_label": "Serie",
  "bracket_header": "Schema · {{seriesName}}",
  "participants_ready": "{{count}} deltagare",
  "empty_state_help": "Skapa schema genom att välja spelformat och spelare. Du kan redigera inställningarna senare.",
  "panel": {
    "settings_step": "1 — Inställningar",
    "players_step": "2 — Spelare",
    "selected_suffix": "valda"
  },
  "delete_format": "Radera format",
  "recreate_warning_title": "Varning: schemat skapas om",
  "recreate_warning_message": "Det nuvarande schemat och alla resultat raderas. Denna åtgärd kan inte ångras.",
  "edit_result": "Redigera",
  "edit_match_result": "Redigera matchresultat",
  "clear_result": "Rensa resultat",
  "result_cleared": "Resultat rensat",
  "cannot_change_winner_next_round_started": "Vinnaren kan inte ändras eftersom nästa rundes match redan har påbörjats",
  "round_0_qualifying": "Kvalificeringsrunda",
  "all_rounds": "Alla rundor",
  "delete_bracket": "Radera schema",
  "publish_bracket": "Publicera schema",
  "hide_bracket": "Dölj schema",
  "bracket_not_published": "Schemat har inte publicerats.",
  "publish_bracket_link": "Publicera.",
  "bracket_published": "Schema publicerat",
  "bracket_unpublished": "Schema dolt",
  "publish_toggle_failed": "Det gick inte att ändra publiceringsstatus",
  "edit_match": "Redigera match",
  "match_updated": "Match uppdaterad",
  "match_update_failed": "Uppdatering av match misslyckades",
  "add_participant": "Lägg till spelare",
  "select_participant": "Välj spelare",
  "cannot_edit_participants_bracket_started": "Spelare kan inte redigeras eftersom matcherna i schemat redan har börjat",
  "confirm_delete_bracket": "Vill du verkligen ta bort schemat?",
  "bracket_deleted": "Schema borttaget",
  "bye_match_info": "Spelaren väntar på nästa motståndare",
  "unseated_players": "Spelare utanför schemat",
  "all_players_seated": "Alla spelare är placerade i schemat",
  "empty_slot": "Tom plats",
  "waiting_for_opponent": "Väntar på motståndare",
  "participant_removed": "Spelare borttagen",
  "participant_remove_failed": "Borttagning av spelare misslyckades",
  "participant_added": "Spelare tillagd",
  "participant_add_failed": "Tillägg av spelare misslyckades",
  "participant_moved": "Spelare flyttad",
  "participant_move_failed": "Flytt av spelare misslyckades",
  "participants_swapped": "Spelare utbytta",
  "cannot_remove_last_participant_from_parent_match": "Du kan inte ta bort den sista spelaren från en match som matar vidare till nästa runda. Byt ut spelaren mot en annan först.",
  "slot_a_waiting_for_winner_info": "Plats A väntar på vinnaren från föregående runda. Du kan endast redigera plats B.",
  "slot_b_waiting_for_winner_info": "Plats B väntar på vinnaren från föregående runda. Du kan endast redigera plats A.",
  "show_bracket": "Hela schemat",
  "show_full_bracket": "Visa hela schemat",
  "bracket_tree": "Matchschema",
  "bracket_round_number_qualifier": "K",
  "finals": "Final",
  "semi_finals": "Semifinal",
  "quarter_finals": "Kvartsfinal",
  "tee": "Tee",
  "tabs": {
    "format": "Format",
    "bracket": "Schema",
    "match_configurations": "Matchkonfigurationer"
  },
  "match_configs": {
    "title": "Matchkonfigurationer",
    "add": "Lägg till konfiguration",
    "edit": "Redigera konfiguration",
    "edit_title": "Redigera konfiguration",
    "delete": "Ta bort konfiguration",
    "delete_blocked": "Konfigurationen kan inte tas bort eftersom den används",
    "deleted": "Konfiguration borttagen",
    "duplicated": "Konfiguration kopierad",
    "duplicate": "Kopiera",
    "duplicate_default_name_suffix": " (kopia)",
    "show_usages": "Visa användning",
    "empty": "Inga konfigurationer",
    "scratch_label": "Inget banval (endast scratch)",
    "no_default": "Inget standard",
    "create_new": "+ Skapa ny konfiguration...",
    "holes_suffix": " hål",
    "override_indicator_tooltip": "Matchen har en egen konfiguration",
    "confirm_edit_count": "Används i {{matchCount}} matcher ({{finalisedCount}} avslutade) och som standard för {{roundCount}} rundor. Vill du fortsätta?",
    "usage_summary": "Används i {{matchCount}} matcher ({{finalisedCount}} avslutade) och som standard för {{roundCount}} rundor.",
    "fields": {
      "name": "Namn",
      "scorecard": "Resultatkort",
      "mens_tee": "Herrars tee",
      "womens_tee": "Damers tee",
      "start_hole": "Starthål",
      "end_hole": "Sluthål",
      "handicap_factor": "Handikappfaktor",
      "men_max_handicap": "Herrars max. handikapp",
      "women_max_handicap": "Damers max. handikapp",
      "team_handicap_percentages": "Laghandikapp-procent (CSV)",
      "holes_range": "Hål",
      "limit_team_handicap_to_min_slope": "Begränsa lagets handikapp till det lägsta individuella handikappet"
    },
    "help": {
      "team_handicap_percentages": "0.5,0.5 – Foursome\n0.6,0.4 – Greensome\n0.35,0.15 – 2-spelares Scramble\n0.25,0.20,0.15,0.10 – 4-spelares Scramble"
    },
    "validation": {
      "name_required": "Namn är obligatoriskt",
      "end_hole": "Sluthålet måste vara större än eller lika med starthålet"
    }
  },
  "round_defaults": {
    "edit_title": "Inställningar - {{round}}",
    "deadline_label": "Tidsgräns",
    "deadline_chip": "Tidsgräns: {{date}}",
    "fixed_date_label": "Fast datum",
    "fixed_date_chip": "{{date}}"
  },
  "match_edit": {
    "config_label": "Konfiguration",
    "use_round_default_named": "Använd rundans standard — {{name}}",
    "use_round_default_no_config": "Använd rundans standard (ingen konfiguration)"
  },
  "tvBoard": {
    "noMatches": "Inga matcher",
    "player": "Spelare",
    "result": "Resultat",
    "thru": "Spel."
  },
  "public": {
    "notYetPublished": "Schemat har inte publicerats ännu",
    "seriesSelectorLabel": "Serie"
  },
  "maximum_score": "Maxresultat",
  "match_config_details": {
    "title": "Matchkonfiguration",
    "scratch": "Ingen konfiguration har angetts — matchen spelas som scratch utan banval.",
    "scratch_label": "Scratch",
    "course": "Bana",
    "mens_tee": "Herrars tee",
    "womens_tee": "Damers tee",
    "hole_range": "Hål",
    "handicap_factor": "Handikappfaktor",
    "men_max_handicap": "Herrars max. handikapp",
    "women_max_handicap": "Damers max. handikapp",
    "team_handicap_percentages": "Laghandikapp (CSV)",
    "limit_team_handicap_to_min_slope": "Övre gräns för lagets handikapp",
    "enabled": "Aktiverad"
  },
  "bracket_properties": {
    "title": "Schemaegenskaper",
    "game_mode": "Spelform",
    "scoring_format": "Resultatberäkning",
    "draw_decision": "Oavgjort-avgörande",
    "handicap": "Handikapp",
    "handicap_scratch": "Scratch",
    "handicap_with_factor": "Med handikapp ({{percent}} %)",
    "handicap_varies": "Varierar — se matchkonfigurationer"
  },
  "tieBreakMode": {
    "label": "Oavgjort-avgörande",
    "EXTRA_HOLES": "Extra hål",
    "MATHEMATICAL": "Matematisk (9/6/3/1)",
    "HANDICAP_LOWER": "Lägre handikapp",
    "PLAYING_HANDICAP_LOWER": "Lägre spelhandikapp"
  },
  "scoring": {
    "title": "Inmatning av rundaresultat",
    "handicapBadge": "(HCP: {{value}})",
    "strokesReceivedThisHole_one": "Handikapp: {{count}} slag",
    "strokesReceivedThisHole_other": "Handikapp: {{count}} slag",
    "matchState": "Läge",
    "allSquare": "A/S",
    "up": "UP",
    "down": "DOWN",
    "holesRemaining": "hål kvar",
    "matchComplete": "Matchen avslutad",
    "matchCompleteBadge": "VINNER MATCHEN",
    "winner": "Vinnare",
    "hole": "Hål",
    "strokes": "Slag",
    "pickedUp": "Plockade upp bollen",
    "conceded": "Given",
    "won": "Vinst",
    "lost": "Förlust",
    "halved": "Delad",
    "thru": "spelade",
    "enterScore": "Resultat per hål",
    "saveScore": "Spara",
    "front9": "Hål 1-9",
    "back9": "Hål 10-18",
    "endGame": "Avsluta matchen",
    "matchSummary": "Matchsammanfattning",
    "confirmResult": "Bekräfta resultat",
    "resetScores": "Rensa resultat",
    "resetShort": "Rensa",
    "resetScoresConfirm": "Vill du verkligen rensa alla matchresultat? Denna åtgärd kan inte ångras.",
    "leadsBy": {
      "matchplay": "{{name}} leder med {{margin}} hål",
      "strokes": "{{name}} leder med {{margin}} slag",
      "points": "{{name}} leder med {{margin}} poäng"
    },
    "tied": {
      "matchplay": "Lika",
      "strokes": "Lika — {{total}}",
      "points": "Lika — {{total}} p"
    },
    "level": "Lika",
    "missingScore": "Resultat saknas",
    "playoff": "playoff",
    "winsMatchBy": {
      "strokes": "Vinner matchen med {{margin}} slag",
      "points": "Vinner matchen med {{margin}} poäng"
    },
    "winsMatch": "vinner matchen",
    "scorecardRequired": "Resultatkort saknas — ange ett resultatkort för beräkning av resultat"
  },
  "hybrid_handicap_random_r0": "Hybrid (handikapp + lottad kvalserie)",
  "manual_seeding_hint": "Du kan åsidosätta den automatiska placeringen genom att ge spelaren ett valfritt placeringsnummer",
  "manual_seed_aria": "Manuell placering",
  "duplicate_seeds_error": "Flera spelare har tilldelats samma placeringsnummer: {{seeds}}. Korrigera innan schemat skapas.",
  "column_player": "Spelare",
  "column_seed": "Placering",
  "registration_open_warning": "Obs! Registreringen är fortfarande öppen.",
  "qualifier_as_round1_label": "Visa inte första rundan som kvalrunda",
  "qualifier_as_round1_help": "När valt är en eventuell första ofullständig runda \"Runda 1\".",
  "reroute": {
    "feedsInto": "Vinnare → Match {{match}}",
    "winner_chip": "Vinnare",
    "success": "Kvalmatchens routing uppdaterad",
    "failed": "Kvalmatchens routing misslyckades"
  },
  "bronze_match": "Bronsmatch",
  "play_bronze_match_label": "Spela bronsmatch",
  "play_bronze_match_help": "Förlorarna i semifinalerna spelar en bronsmatch om tredje plats.",
  "bronze_requires_two_semifinals": "Bronsmatchen kräver två semifinaler",
  "ryderCup": {
    "title": "Lagmatch",
    "management_title": "Hantering av lagmatch",
    "create": "Skapa lagmatch",
    "players_assigned_next": "Spelare väljs inte här — de fördelas till lag i nästa steg i lagmatchens hantering.",
    "tab_teams": "Lag",
    "tab_sessions": "Omgångar",
    "tab_scoreboard": "Resultat",
    "team_name": "Lagets namn",
    "team_colour": "Lagets färg",
    "no_members": "Inga spelare",
    "unassigned": "Inget lag",
    "move_to_team_right": "{{team}} →",
    "move_to_team_left": "← {{team}}",
    "unequal_team_sizes_warning": "Lagen är olika stora ({{a}} vs {{b}} spelare)",
    "session": "Omgång",
    "session_default": "Omgång {{number}}",
    "add_session": "Skapa omgång",
    "session_name": "Namn",
    "delete_session": "Ta bort omgång",
    "delete_session_confirm": "Vill du verkligen ta bort omgången och alla dess matcher?",
    "add_match": "Lägg till match",
    "select_player": "Välj spelare",
    "already_in_session": "Redan i match",
    "delete_match": "Ta bort match",
    "delete_match_confirm": "Vill du verkligen ta bort denna match?",
    "delete_result": "Ta bort resultat",
    "delete_result_confirm": "Vill du verkligen ta bort matchens resultat? Matchen återgår till ospelad.",
    "error_same_team": "Båda spelarna är i samma lag",
    "error_duplicate_in_session": "Spelaren finns redan i denna omgång",
    "no_sessions_yet": "Inga omgångar. Skapa en omgång först.",
    "no_matches_in_session": "Inga matcher i denna omgång.",
    "finalize_as": "Avsluta A/S (oavgjort)",
    "finalize_as_confirm": "Vill du verkligen avsluta matchen som oavgjord (A/S)?",
    "finalize_as_header": "Avsluta match A/S",
    "enter_result": "Ange resultat",
    "edit_result": "Redigera resultat",
    "reopen_match": "Öppna matchen igen",
    "reopen_match_confirm": "Matchen är redan avslutad. Att redigera resultatet öppnar matchen igen och tar bort det nuvarande resultatet (hålvisa resultat behålls) tills du bekräftar det på nytt. Lagets poäng tas bort från resultattavlan tills dess. Vill du fortsätta?",
    "reopen_match_confirm_action": "Öppna igen",
    "score": "Resultat",
    "confirm_finish": "Vill du verkligen avsluta matchen? Resultatet beräknas utifrån angivna resultat (vid lika ställning A/S).",
    "team_wins": "{{team}} vinner",
    "halved_as": "Oavgjort (A/S)",
    "result_notation": "Resultatnotering",
    "result_notation_placeholder": "t.ex. 3&2, 1 up",
    "edit_schedule": "Redigera schema",
    "start_date": "Datum",
    "start_time": "Starttid",
    "start_tee": "Starthål",
    "tee_n": "Hål {{n}}",
    "scoreboard": "Resultat",
    "session_breakdown": "Poäng per session",
    "team": "Lag",
    "actual": "Poäng",
    "projected": "Prognos",
    "projected_short": "Prognos",
    "tie": "Oavgjort",
    "wins": "vinner",
    "scoreboard_not_available": "Resultattavlan för lagmatchen är inte tillgänglig",
    "as_short": "A/S",
    "up_short": "UP",
    "final_short": "Slut",
    "halved_short": "Delad",
    "thru_short": "Spe.",
    "time_short": "kl.",
    "session_settings": "Sessionsinställningar",
    "publish": "Publicera matcher",
    "unpublish": "Dölj matcher",
    "not_published": "Resultaten har inte publicerats ännu.",
    "publish_link": "Publicera.",
    "published": "Matcher publicerade",
    "unpublished": "Matcher dolda",
    "delete": "Ta bort lagmatch",
    "confirm_delete_title": "Ta bort lagmatch?",
    "confirm_delete_body": "Detta tar permanent bort lag, sessioner och matcher. Åtgärden kan inte ångras.",
    "deleted": "Lagmatchen har tagits bort",
    "props": {
      "game_mode": "Lagmatch",
      "scoring": "Matchspel"
    }
  }
}
